import styled from "styled-components";

import {
  Box,
  Container,
  FlexDiv,
  SVGSprite,
  getCustomScroll,
} from "../../Atoms";
import Typography from "../../../foundation/Typography/V2";

export const SliderWrapper = styled(Box)`
  margin: 0 -20px;
  .slick-prev,
  .slick-next {
    top: -15px;
    display: block !important;
    height: 38px;
    width: 38px;
    &:before {
      height: 100%;
      width: 100%;
      content: "";
      background: url(${({ arrowImage }) => `/images/${arrowImage}`}) center
        no-repeat;
      background-size: 100%;
      display: block;
      opacity: 1;
    }
    &.slick-disabled {
      &:before {
        opacity: 0.25;
      }
    }
    @media only screen and (max-width: 395px) {
      top: -25px;
    }
  }
  .slick-next {
    right: 10px;
  }
  .slick-prev {
    left: unset;
    right: 55px;
    &:before {
      transform: rotateY(180deg);
    }
  }
  .slick-track {
    display: flex !important;
  }

  .slick-slide {
    height: auto !important;
  }
  .slick-list {
    padding: 30px 0;
  }
  .slick-slide {
    & > div {
      display: flex;
      height: 100%;
      margin: 0 20px;
      @media only screen and (max-width: 1023px) {
        margin: 0;
        padding: 0 8px;
      }
    }
    &:last-child {
      @media only screen and (max-width: 1023px) {
        > div {
          padding-right: 16px;
        }
      }
    }
    &:first-child {
      @media only screen and (max-width: 1023px) {
        > div {
          padding-left: 16px;
        }
      }
    }
  }
  @media only screen and (max-width: 1023px) {
    margin: 0;
  }
`;

export const CardWrapper = styled(FlexDiv)`
  padding: 40px 24px 40px;
  position: relative;
  border-radius: 24px;
  display: flex !important;
  flex-direction: column;
  min-height: 328px;
  outline: 0;
  box-shadow: 0px 13.5541px 13.5541px
    rgba(${({ theme }) => theme.colors.shadows.black}, 0.02);
  border: 1px solid ${({ theme }) => theme.colorsV2.gray.shade_100};
`;

export const Quotes = styled(SVGSprite)`
  position: absolute;
  fill: ${({ theme }) => theme.colorsV2.warning.shade_300};
  ${({ invert }) =>
    invert === "true"
      ? `
  bottom: -24px;
  right: 0px;
  transform: rotate(180deg);
  `
      : `
  top: -24px;
  left: 0px;
  `};
`;

export const TestimonialContainer = styled(Container)`
  @media only screen and (max-width: 1024px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

export const Text = styled(Typography)`
  @media only screen and (max-width: 1024px) {
    padding-left: 15px;
  }
`;

export const Description = styled(Typography)`
  max-height: 142px;
  overflow: auto;
  color: ${({ theme }) => theme.colorsV2.gray.shade_700};
  ${getCustomScroll({})};
`;
export const Wrapper = styled(FlexDiv)`
  background-color: ${({ theme }) => theme.colorsV2.blueGray.shade_50};
  padding: 98px 0 86px 0;
`;
export const Name = styled(Typography)`
  color: ${({ theme }) => theme.colorsV2.gray.shade_800};
  flex: 1;
  display: flex;
  align-items: flex-end;
`;
export const QuotesWrapper = styled(FlexDiv)`
  position: relative;
`;

export const AvatarContainer = styled(FlexDiv)`
  gap: 8px;
  align-items: center;
`;

export const Avatar = styled.img`
  height: 48px;
  width: 48px;
  border-radius: 50%;
  object-fit: cover;
`;
